/**
 * Which cloud this bundle was built for. One read of the build environment, with NO default.
 *
 * It lives here rather than in `firebase.ts` because a screen that only needs to KNOW the project must
 * not have to pull in the Firebase SDK (and a browser `window`) to ask. `firebase.ts` initialises the
 * SDK from this same constant, so the two can never disagree about which project the console is on.
 */
export const firebaseProjectId = import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '';

/**
 * Which cloud this console is driving, named ONLY when it is not the production one — owner ruling
 * 2026-09-16: *"in what world would you show 'prod' in a product used by end consumers?"*
 *
 * The console a venue uses says nothing about environments: the word is ours, not theirs, and the only
 * build it could ever appear on is the one they are running. A build pointed anywhere else names the
 * project it is pointed at, so a session spent driving dev controllers is not mistaken for the real
 * room. An unconfigured build names nothing — it is not talking to a cloud at all.
 */
export const nonProductionEnvironment = firebaseProjectId === 'nuance-venue-prod'
  ? ''
  : firebaseProjectId === 'nuance-venue-dev'
    ? 'dev'
    : firebaseProjectId;
